import { authRequest } from "~/utils/api";

import { showAppMessage } from "~/redux/actions/app";

export const GET_MESSAGE_COUNT = "GET_MESSAGE_COUNT";
export const SET_MESSAGE_COUNT = "SET_MESSAGE_COUNT";
export const getMessageCount = (token) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/messages/read`,
      method: "GET",
    })
      .then((res) => {
        dispatch({ type: SET_MESSAGE_COUNT, count: res.data });
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

export const SET_MESSAGE_LIST = "SET_MESSAGE_LIST";
export const getMessageList = (token, params, callback) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/messages`,
      method: "GET",
      params: params,
    })
      .then((res) => {
        callback && callback(res.data);
        dispatch({ type: SET_MESSAGE_LIST, list: res.data });
        dispatch(getMessageCount(token));
      })
      .catch((err) => {
        callback && callback(null);
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};

export const readMessages = (token, messageIds) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/messages/read`,
      method: "PUT",
      data: { user_message_ids: messageIds },
    })
      .then(() => {
        dispatch(getMessageCount(token));
      })
      .catch((err) => {
        dispatch(showAppMessage(err.message, "error"));
      });
  };
};
